import React, { useEffect, useState, useLayoutEffect } from "react";
import "./Dashboard.scss";
import { API, graphqlOperation } from "aws-amplify";
import {
	listUserInfos,
	listPayments,
	listProductTables,
	productById,
} from "../../graphql/queries";
import { Container, Typography } from "@mui/material";
import Table from "../../components/Tables/UsersTable";
import UsersPayment from "../../components/Tables/UsersPayment";
import AdminHeader from "../../components/Headers/AdminHeader";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import TextField from "../../components/Textfield/Textfield";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import moment from "moment";
import { useSelector } from "react-redux";
import CampaignTable from "../../components/Tables/CampaignTable";
import ActiveCampaign from "../../components/Tables/ActiveCampaign";
import FinishCampaign from "../../components/Tables/FinishCampaign";
import DraftCampaign from "../../components/Tables/DraftCampaign";
function TabPanel(props) {
	const { children, value, index, ...other } = props;
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ pt: 2 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		"aria-controls": `full-width-tabpanel-${index}`,
	};
}

export default function AdminBoard() {
	const theme = useTheme();
	const [value, setValue] = React.useState(0);
	const [users, setUsers] = useState([]);
	const [orders, setOrders] = useState([]);
	const [garments, setGarments] = useState([]);
	const [draft, setDraft] = React.useState([]);
	const [finish, setFinish] = React.useState([]);
	const [active, setActive] = React.useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState("");
	const [index, setIndex] = React.useState(0);
	const logindata = useSelector((state) => state.login);
	const fetchUsers = async () => {
		setLoading(true);
		let nextToken = null;
		let items = [];
		try {
			do {
				const users = await API.graphql(
					graphqlOperation(listUserInfos, {
						nextToken,
						limit: 400,
					}),
				);
				items = items.concat(
					users.data.listUserInfos.items.sort(
						(a, b) =>
							new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
					),
				);
				nextToken = users.data.listUserInfos.nextToken;
			} while (nextToken);
			setUsers(items);
			setLoading(false);
		} catch (e) {
			setLoading(false);
		}
	};

	const fetchOrders = async () => {
		setLoading(true);
		// try {
		// 	const orders = await API.graphql(graphqlOperation(listPayments));
		// 	setOrders(orders.data.listPayments.items);
		// 	setLoading(false);
		// } catch (err) {
		// 	setLoading(false);
		// }

		let nextToken = null;
		let items = [];
		try {
			do {
				const orders = await API.graphql(
					graphqlOperation(listPayments, {
						nextToken,
						limit: 400,
					}),
				);
				items = items.concat(
					orders.data.listPayments.items.sort(
						(a, b) =>
							new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
					),
				);
				nextToken = orders.data.listPayments.nextToken;
			} while (nextToken);
			setOrders(items);
			setLoading(false);
		} catch (e) {
			setLoading(false);
		}
	};

	const fetchGarments = async () => {
		setLoading(true);

		let nextToken = null;
		let items = [];
		try {
			do {
				const garment = await API.graphql(
					graphqlOperation(listProductTables, {
						nextToken,
						limit: 400,
					}),
				);
				items = items.concat(
					garment.data.listProductTables.items.sort(
						(a, b) =>
							new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
					),
				);
				nextToken = garment.data.listProductTables.nextToken;
			} while (nextToken);
			setGarments(items);
			setLoading(false);
		} catch (e) {
			setLoading(false);
		}
	};

	const remainDate = (createdAt, days) => {
		const currentDate = moment(createdAt, "YYYY-MM-DD");
		const futureDate = moment(currentDate._d).add(days, "days");
		const endDate = moment(futureDate._d).format("YYYY-MM-DD");
		const todaysdate = moment();
		return moment(endDate).diff(todaysdate, "days");
	};

	useEffect(() => {
		!users.length && fetchUsers();
		!orders.length && fetchOrders();
		fetchGarments();
	}, []);

	useLayoutEffect(() => {
		const drafted = garments.filter((data, ind) => !data.isDone);
		setDraft(drafted);
		const finished = garments.filter(
			(data, ind) =>
				(data.isDone && remainDate(data.createdAt, data.days) + 1 <= 0) ||
				data.isStop,
		);
		setFinish(finished);
		const actived = garments.filter(
			(data, ind) =>
				!(data.isDone && remainDate(data.createdAt, data.days) + 1 <= 0) &&
				!data.isStop &&
				data.isDone,
		);
		setActive(actived);
	}, [garments]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		setSearch("");
	};

	const handleChangeIndex = (index) => {
		setValue(index);
	};

	const campaignData = [
		{ key: "Total", num: garments?.length },
		{ key: "Active", num: garments?.length - (finish.length + draft?.length) },
		{ key: "Draft", num: draft?.length },
		{ key: "Finished", num: finish.length },
	];

	if (loading && !users.length) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<CircularProgress />
			</Box>
		);
	}
	return (
		<>
			<Container maxWidth="xxl">
				<AdminHeader />
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<Typography
						variant="h5"
						component="h1"
						sx={{ fontWeight: "bold", textAlign: "center", marginBottom: 2 }}
					>
						User Details
					</Typography>
					<Box sx={{ display: "flex" }}>
						{value === 2 && (
							<>
								{campaignData.map((item, ind) => {
									return (
										<Box
											sx={{
												display: "flex",
											}}
											onClick={() => setIndex(ind)}
										>
											<Typography
												variant="h6"
												sx={{
													fontWeight: "bold",
													padding: "2px",

													marginTop: "15px",
													"&:hover": {
														cursor: "pointer",
													},
													backgroundColor: ind === index && "#c4c4c4",
												}}
											>
												{item.key} :
											</Typography>
											<Typography
												variant="h6"
												sx={{
													marginTop: "15px",
													padding: "2px",
													marginRight: ind !== 3 && "30px",
													backgroundColor: ind === index && "#c4c4c4",
												}}
											>
												{item.num}
											</Typography>
										</Box>
									);
								})}
							</>
						)}
					</Box>
					<Box sx={{ marginRight: "12px" }}>
						{/* {value === 0 ? ( */}
						<TextField
							type="text"
							placeholder="Search..."
							onChange={(e) => setSearch(e.target.value)}
							value={search}
						/>
						{/* // ) : null} */}
					</Box>
				</Box>
				<Box sx={{ bgcolor: "background.paper" }}>
					<AppBar position="static" sx={{ background: "#000" }}>
						<Tabs
							value={value}
							onChange={handleChange}
							textColor="inherit"
							variant="fullWidth"
							TabIndicatorProps={{
								style: {
									backgroundColor: "#fff",
								},
							}}
						>
							<Tab
								label="Users"
								{...a11yProps(0)}
								style={{ fontWeight: "900" }}
							/>
							<Tab
								label="User Orders "
								{...a11yProps(1)}
								style={{ fontWeight: "900" }}
							/>
							<Tab
								label="User Campaign "
								{...a11yProps(2)}
								style={{ fontWeight: "900" }}
							/>
						</Tabs>
					</AppBar>
					<SwipeableViews
						axis={theme.direction === "rtl" ? "x-reverse" : "x"}
						index={value}
						onChangeIndex={handleChangeIndex}
					>
						<TabPanel value={value} index={0} dir={theme.direction}>
							<Table users={users} searchKey={search} />
						</TabPanel>
						<TabPanel value={value} index={1} dir={theme.direction}>
							<UsersPayment payments={orders} searchKey={search} />
						</TabPanel>
						<TabPanel value={value} index={2} dir={theme.direction}>
							{index === 0 ? (
								<CampaignTable campaign={garments} searchKey={search} />
							) : index === 1 ? (
								<ActiveCampaign campaign={active} searchKey={search} />
							) : index === 2 ? (
								<DraftCampaign campaign={draft} searchKey={search} />
							) : (
								<FinishCampaign campaign={finish} searchKey={search} />
							)}
						</TabPanel>
					</SwipeableViews>
				</Box>
			</Container>
		</>
	);
}
